import React from 'react';
import * as Styled from './MListNav.styles';
import { ABody, ABodySize } from '../../atoms/ABody/index';
import { AIcon, AIconSize } from '../../atoms/AIcon/index';
import { MListNavProps, MListNavType } from './MListNav.types';

const DEFAULT_ARROW_ICON = 'icon-arrow-right';

const TextContent: React.FC<{
  text: string;
  textSize: ABodySize;
  type?: MListNavType;
  ctaLink: string;
}> = ({ text, textSize, type, ctaLink }) => {
  const body = <ABody size={textSize} bodyText={text} />;

  if (type === MListNavType.Link) {
    return (
      <Styled.Decorate data-testid={`MListNavDecorate-${text}`} ctaLink={ctaLink}>
        {body}
      </Styled.Decorate>
    );
  }

  return body;
};

export const MListNav: React.FC<MListNavProps> = ({
  text,
  arrow = false,
  aIcon,
  textSize = ABodySize.S,
  arrowIcon,
  size = AIconSize.L,
  onClick,
  type,
  ctaLink,
}) => {
  const resolvedArrowIcon = arrowIcon || DEFAULT_ARROW_ICON;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && onClick) {
      e.preventDefault();
      onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
    }
  };

  return (
    <Styled.Wrapper
      data-testid={`MListNav-${text}`}
      ctaLink={ctaLink}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={ctaLink || onClick ? 0 : -1}
      role={ctaLink ? 'link' : onClick ? 'button' : undefined}
    >
      {aIcon && <AIcon size={size} {...aIcon} />}
      <TextContent text={text} textSize={textSize} type={type} ctaLink={ctaLink} />
      {arrow && (
        <Styled.ArrowIcon>
          <AIcon size={size} icon={resolvedArrowIcon} />
        </Styled.ArrowIcon>
      )}
    </Styled.Wrapper>
  );
};
